import React from 'react';
import { Download, CheckCircle } from 'lucide-react';

const LogoDownload = () => {
  const handleDownload = () => {
    // Create download link
    const link = document.createElement('a');
    link.href = '/images/taxi98-logo-transparent.png';
    link.download = 'taxi98-logo-transparent.png';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleRightClick = (e) => {
    // Allow right-click to save image
    e.preventDefault();
    const link = document.createElement('a');
    link.href = '/images/taxi98-logo-transparent.png';
    link.download = 'taxi98-logo-transparent.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-2xl p-12">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-3">
              Taxi-98 Logo Download
            </h1>
            <p className="text-lg text-gray-600">
              High-quality transparent PNG logo
            </p>
          </div>

          {/* Logo Preview */}
          <div className="mb-8 p-8 bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl border-2 border-cyan-200">
            <div className="flex items-center justify-center">
              <img
                src="/images/taxi98-logo-transparent.png"
                alt="Taxi-98 Transparent Logo"
                className="max-w-md w-full h-auto cursor-pointer"
                onContextMenu={handleRightClick}
                title="Right-click to save or use button below"
              />
            </div>
            <p className="text-center text-sm text-gray-500 mt-4">
              Right-click image to save, or use download button below
            </p>
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-green-50 p-6 rounded-xl border border-green-200">
              <CheckCircle className="w-8 h-8 text-green-600 mb-3" />
              <h3 className="font-bold text-gray-900 mb-2">Transparent Background</h3>
              <p className="text-sm text-gray-600">White background completely removed</p>
            </div>
            <div className="bg-blue-50 p-6 rounded-xl border border-blue-200">
              <CheckCircle className="w-8 h-8 text-blue-600 mb-3" />
              <h3 className="font-bold text-gray-900 mb-2">High Resolution</h3>
              <p className="text-sm text-gray-600">1024x1024 pixels, perfect quality</p>
            </div>
            <div className="bg-purple-50 p-6 rounded-xl border border-purple-200">
              <CheckCircle className="w-8 h-8 text-purple-600 mb-3" />
              <h3 className="font-bold text-gray-900 mb-2">PNG Format</h3>
              <p className="text-sm text-gray-600">Optimized for web and print</p>
            </div>
          </div>

          {/* Specifications */}
          <div className="bg-gray-50 p-6 rounded-xl mb-8 border border-gray-200">
            <h3 className="font-bold text-gray-900 mb-4">File Specifications</h3>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="text-gray-600">Format:</span>
                <span className="ml-2 font-semibold text-gray-900">PNG with Alpha Channel</span>
              </div>
              <div>
                <span className="text-gray-600">Dimensions:</span>
                <span className="ml-2 font-semibold text-gray-900">1024 x 1024 pixels</span>
              </div>
              <div>
                <span className="text-gray-600">Background:</span>
                <span className="ml-2 font-semibold text-gray-900">Transparent (474,739 white pixels removed)</span>
              </div>
              <div>
                <span className="text-gray-600">Usage:</span>
                <span className="ml-2 font-semibold text-gray-900">Web, Print, Marketing</span>
              </div>
            </div>
          </div>

          {/* Download Buttons */}
          <div className="text-center space-y-4">
            <button
              onClick={handleDownload}
              className="inline-flex items-center space-x-3 px-8 py-4 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-xl font-bold text-lg hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              <Download className="w-6 h-6" />
              <span>Download Transparent Logo</span>
            </button>
            
            {/* Direct Link */}
            <div className="flex items-center justify-center space-x-4">
              <span className="text-gray-600">Or</span>
              <a
                href="/images/taxi98-logo-transparent.png"
                download="taxi98-logo-transparent.png"
                className="text-cyan-600 hover:text-cyan-700 font-semibold underline"
              >
                Click here for direct download
              </a>
            </div>
            
            <p className="mt-4 text-sm text-gray-500">
              File name: taxi98-logo-transparent.png
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoDownload;
